let timeTarget;
let countDownTarget;
export class GameTimer{
	constructor(){
		this.startTime 	= 0;
		this.elapsed 	= 0;
		this.running 	= false;
		timeTarget = document.querySelector(".c-time .js-time");
		countDownTarget = document.querySelector(".c-time .js-left");
	}
	start(){
		if (this.running) return;
		this.running = true;
		//console.log("start");
		this.startTime = performance.now() - this.elapsed;
		this.updateDisplay();
	}
	pause(){
		if (!this.running) return;
		this.running = false;
		this.elapsed = performance.now() - this.startTime;
	}
	reset() {
		this.running = false;
		this.elapsed = 0;
		this.startTime = 0;
	}
	getElapsed() {
		if (this.running) {
			return performance.now() - this.startTime;
		}
		return this.elapsed;
	}
	getFormatted() {
		//const total = Math.floor(this.getElapsed() / 1000);
		//const min = String(Math.floor(total / 60)).padStart(2, "0");
		//const sec = String(total % 60).padStart(2, "0");
		
		let ms 		= Math.floor(this.getElapsed());
		const min 	= String(Math.floor(ms / 60000)).padStart(2, "0");
		const sec 	= String(Math.floor((ms % 60000) / 1000)).padStart(2, "0");
		const milli = String(Math.floor(ms % 1000)).padStart(3, "0");
		return `${min}:${sec}:${milli}`
	}
	
	updateDisplay() {
		timeTarget.innerHTML = this.getFormatted();
		if (this.running) {
			requestAnimationFrame(() => this.updateDisplay());
		}
	}
	
	addPenalty(seconds = 5) {
		this.startTime -= seconds * 1000;
		let $penalty = document.querySelector(".c-penalty");
		$penalty.classList.add("show");
		$penalty.addEventListener("animationend", function(e){
			$penalty.classList.remove("show");
		}, {
			"once": true
		})
	}
}